import React, { useState, useEffect } from "react";
import ModalInDrawer from "../ui/ModalInDrawer";
import axios from "axios";
import { BACKEND } from "../../config/configEnvs";
import { toast } from "react-toastify";
import Datepicker from "react-tailwindcss-datepicker";
import useFetchRequestGet from "../../hooks/useFetch";
import { FaCheck, FaFileImport, FaIdCardAlt, FaInfoCircle } from "react-icons/fa";
import FormLoader from "../ui/FormLoader";
import { Button } from "@mui/material";
import GetCountries from "../../utils/getData/GetCountries";
import FetchDNI from "../../utils/externalAPIs/FetchDNI";
import FetchRUC from "../../utils/externalAPIs/FetchRuc";
import countryCodes from "../../constants/countrycodes.json";
import { FetchRucPeru } from "../../utils/externalAPIs/FetchRucPeru";

const NuevoClienteDialog = ({ open, onClose, title, onSuccess, setClientEmail, setClientPassword }) => {
  
  const [countryNames, setCountryNames] = useState([])
  const [currentCountry, setCurrentCountry] = useState("18");
  const [countryName, setCountryName] = useState("")


  useEffect(() => {
    GetCountries({setter: setCountryNames})
  }, [])
  
  const [nicho, setNicho] = useState("");
  const [currentRubro, setCurrentRubro] = useState("");
  const [newClientData, setNewClientData] = useState({
    nombre: "",
    email: "",
    password: "",
    pais: countryName,
    razonSocial: "",
    ruc: "0",
    dni: "",
    fechaAniversario: {
      startDate: null,
      endDate: null,
    },
    direccion: "",
    nEmpleados: "0",
    rubro: "",
    ingresosAnuales: "",
    nombreGerente: "",
    cumpleaniosGerente: {
      startDate: null,
      endDate: null,
    },
    telefonoGerente: "+51",
    emailGerencia: "",
    encargadoProyecto: "",
    telefono: "+51",
    fechaCumpleanios: {
      startDate: null,
      endDate: null,
    },
    puestoTrabajo: "",
  });

  const resetNewClientData = () => {
    setNewClientData({
      nombre: "",
      email: "",
      password: "",
      pais: countryName,
      razonSocial: "",
      ruc: "0",
      dni: "",
      fechaAniversario: {
        startDate: null,
        endDate: null,
      },
      direccion: "",
      nEmpleados: "0",
      rubro: "",
      ingresosAnuales: "",
      nombreGerente: "",
      cumpleaniosGerente: {
        startDate: null,
        endDate: null,
      },
      telefonoGerente: "+51",
      emailGerencia: "",
      encargadoProyecto: "",
      telefono: "+51",
      fechaCumpleanios: {
        startDate: null,
        endDate: null,
      },
      puestoTrabajo: "",
    })
  }

  useEffect(() => {
    const country = countryNames.find(country => country.id === Number(currentCountry))
    if (country) {
      setNewClientData(prevState => ({
        ...prevState,
        pais: country.name
      }))
    }
  }, [currentCountry, countryNames])

  const createNewClient = async (e) => {
    try {
      e.preventDefault()
      if (!leadValidate) {
        toast.error("Ingresa y valida el ID del lead")
        return
      }
      await axios.post(`${BACKEND}/api/clientesUser`, {
        nombreComercial: newClientData.nombre,
        email: newClientData.email,
        password: newClientData.password,
        razonSocial:newClientData.razonSocial,
        ruc: newClientData.ruc,
        dni: newClientData.dni,
        pais:newClientData.pais,
        fechaAniversario:newClientData.fechaAniversario.startDate,
        direccion:newClientData.direccion,
        nEmpleados:newClientData.nEmpleados,
        ingresosAnuales:newClientData.ingresosAnuales,
        nombreGerente:newClientData.nombreGerente,
        cumpleaniosGerente:newClientData.cumpleaniosGerente.startDate,
        telefonoGerente:newClientData.telefonoGerente,
        emailGerencia:newClientData.emailGerencia,
        encargadoProyecto:newClientData.encargadoProyecto,
        telefono:newClientData.telefono,
        fechaCumpleanios:newClientData.fechaCumpleanios.startDate,
        puestoTrabajo:newClientData.puestoTrabajo,
        nicho:nicho ? nicho : null
      })

      onClose()
      onSuccess()
      resetNewClientData()
      toast.success("Cliente creado exitosamente")

    } catch (e) {
      console.log(e)
      toast.error("Error al crear el cliente: " + e)
    }
  }

  const { dataList: listRubros } = useFetchRequestGet({
    endpoint: "clientesRubros",
    page: 1,
    limit: 20,
  });

  const { dataList: listNichos } = useFetchRequestGet({
    endpoint: "clientesNichos",
    page: 1,
    limit: 50,
    query:currentRubro ? `&where[rubro][equals]=${currentRubro}` : ""
  });

  /// Importación de leads

  const [leadInput, setLeadInput] = useState("")
  const [leadValidate, setLeadValidate] = useState(false)
  const [isLeadLoading, setIsLeadLoading] = useState(false)

  const [isDniLoading, setIsDniLoading] = useState(false)
  const [dniVerify, setDniVerify] = useState(false)

  const [isRucLoading, setIsRucLoading] = useState(false)
  const [rucVerify, setRucVerify] = useState(false)

  const getLeadData = async (leadId) => {
    if (!leadId || leadId.length !== 24) {
      toast.warning("Ingresa un ID válido!")
      return
    }

    try {
      setIsLeadLoading(true)
      const { data } = await axios.get(`${BACKEND}/api/registroLeads/${leadId}`)

      const selectedCountry = countryNames.find(country => country.id === Number(currentCountry))
      const matchedCountryCode = countryCodes.find(c => c.code === selectedCountry?.code)
      const dialCode = matchedCountryCode ? matchedCountryCode.dial_code : "+51"

      setNewClientData((prev) => ({
        ...prev,
        nombre: data.leadName || "",
        email: data.email || "",
        razonSocial: data.brandName || "",
        ruc: data.ruc || "",
        dni: data.dni || "",
        telefonoGerente: formatPhoneWithDialCode(data.phone || "", dialCode),
        emailGerencia: data.email || "",
        encargadoProyecto: data.leadName || "",
        telefono: formatPhoneWithDialCode(data.phone || "", dialCode),
        puestoTrabajo: data.position || "",
      }))

      setLeadValidate(true)
      setDniVerify(true)
      setRucVerify(true)
      toast.success("Lead importado con éxito")
    } catch (e) {
      toast.error("Error al validar el ID: " + e)
    } finally {
      setIsLeadLoading(false)
    }
  } 

  const dniCheckHandler = async ({dni, setter}) => {
    if (dni.length < 8) {
      toast.warning("DNI inválido - debe tener 8 dígitos");
      return;
    }
    
    try {
      const nombre = await FetchDNI({
        dni: dni, 
        loadingSetter: setIsDniLoading
      });
      
      if (nombre) {
        setter((prev) => ({
          ...prev, 
          nombreGerente: nombre,
        }));
        setDniVerify(true)
        toast.success("DNI validado exitosamente");
      } else {
        toast.error("DNI no encontrado");
      }
    } catch (error) {
      toast.error("Error al validar DNI");
    }
  }

  const rucCheckHandler = async ({ruc, setter}) => {
    if (ruc.length !== 11) {
      toast.warning("RUC inválido - debe tener 11 dígitos");
      return;
    }
    
    try {
      // const { brandName, direccion } = await FetchRUC({
      //   ruc: ruc, 
      //   loadingSetter: setIsRucLoading
      // });
      // if (brandName) {
      //   setter((prev) => ({
      //     ...prev, 
      //     razonSocial: brandName,
      //     nombreComercial: brandName,
      //     direccion: direccion,
      //   }));
      //   setRucVerify(true)
      //   toast.success("RUC validado exitosamente");
      // } else {
      //   toast.error("RUC no encontrado");
      // }

      const { empresa, direccion } = await FetchRucPeru({ ruc: ruc, type: "ruc" });
      const { docType, dni, nombre, cargo } = await FetchRucPeru({ ruc, type: "ruc_representantes" });
      setter((prev) => ({
        ...prev, 
        razonSocial: empresa || "",
        nombreComercial: empresa || "",
        direccion: direccion || "",
        nombreGerente: nombre || "",
        puestoTrabajo: cargo || "",
        dni: dni || "",
      }));
    } catch (error) {
      toast.error("Error al validar DNI");
    }
  }

  const formatPhoneWithDialCode = (currentPhone, dialCode) => {
    const desiredDial = (dialCode || "+51").trim();
    const phone = (currentPhone || "").toString().trim();
    if (!phone) return desiredDial;
    const leadingMatch = phone.match(/^\s*(\+\d{1,4})\s*(.*)$/);
    if (leadingMatch) {
      const existingDial = leadingMatch[1];
      const restNumber = leadingMatch[2].trim();
      if (existingDial === desiredDial) return phone; // already correct
      return restNumber ? `${desiredDial} ${restNumber}` : `${desiredDial}`;
    }
    return `${desiredDial} ${phone}`;
  }

  const countryCodeHandler = ({countryId, setter}) => {
    // console.log("Numero de pais: " + countryId)
    const country = countryNames.find(c => c.id === Number(countryId));
    // console.log("Pais encontrado: " + country)
    const countryCode = countryCodes.find(c => c.code === country?.code);
    // console.log("Codigo de pais encontrado: " + countryCode)
    const dialCode = countryCode ? countryCode.dial_code : "+51";
    setter(prev => ({
      ...prev,
      telefono: formatPhoneWithDialCode(prev?.telefono, dialCode),
      telefonoGerente: formatPhoneWithDialCode(prev?.telefonoGerente, dialCode)
    }))
  }

  useEffect(() => {
    if (newClientData.dni === "") {
      setDniVerify(false)
    }
    if (newClientData.ruc === "") {
      setRucVerify(false)
    }
  }, [newClientData.dni, newClientData.ruc])

  return (
    <ModalInDrawer 
      activeModal={open} 
      onClose={() => {
        onClose()
        setLeadInput("")
        setLeadValidate(false)
        resetNewClientData()
      }} 
      title={title}
      centered
      className="max-w-3xl"
    >
      <form 
        className="w-full"  
        onSubmit={createNewClient} 
      >
        <div className="flex flex-col gap-4 items-center justify-center">

          <span className="text-xs w-full items-start inline-flex gap-2 px-3 text-gray-600 mb-2">
            <FaInfoCircle /> A partir de ahora las cotizaciones estarán vinculadas a un lead o a un cliente
          </span>
          
          <div className="mb-4 w-full">

            <div className="flex">
              <span className="text-xs inline-flex font-bold items-center gap-2 px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                <FaFileImport /> Importar Lead
              </span>
              <input
                type="text"
                placeholder="Ingresa el ID de un lead para importarlo"
                value={leadInput}
                disabled={leadValidate}
                onChange={(e) => setLeadInput(e.target.value)}
                className="text-xs rounded-none bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
              />

              {leadValidate ? (
                <div className="inline-flex gap-2 items-center px-3 text-xs text-white bg-green-500 border border-s-0 rounded-e-0 border-gray-300 border-e-0 rounded-e-md ">
                  Validado
                  <FaCheck className=" text-white" />
                </div>
              ) : (
                <button
                  type="button"
                  onClick={() => getLeadData(leadInput)}
                  disabled={isLeadLoading}
                  className="inline-flex  gap-2 items-center px-3 text-xs text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-s-0 rounded-e-md "
                >
                  {isLeadLoading ? (
                    <FormLoader colour={"#F64000"} className={" w-4"} />
                  ) : (
                    <>
                      Validar
                      <FaCheck />
                    </>
                  )}
                </button>
              )}
            </div>
          </div>

          <div className="flex flex-row items-start gap-4 justify-center w-full">

            <div className="flex flex-col gap-2 items-center justify-center w-1/2">

              {/* DNI */}
              <div className="mb-2 w-full">
                <label className="text-xs block text-gray-700 mb-1">
                    DNI
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-100 border rounded-e-0 border-gray-100 border-e-0 rounded-s-md">
                    <FaIdCardAlt />
                  </span>
                  <input
                    type="text"
                    placeholder="DNI del usuario"
                    required
                    value={newClientData.dni}
                    onChange={(e) => setNewClientData((prev) => ({...prev, dni: e.target.value}))}
                    className="text-xs rounded-none border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-100 p-2.5" 
                  />

                  {dniVerify ? (
                    <div className="inline-flex gap-2 items-center px-3 text-xs text-white bg-green-500 border border-s-0 rounded-e-0 border-gray-100 border-e-0 rounded-e-md ">
                      Validado
                      <FaCheck className=" text-white" />
                    </div>
                  ) : (
                    <button
                      type="button"
                      onClick={() => dniCheckHandler({dni: newClientData.dni, setter: setNewClientData})}
                      disabled={isDniLoading}
                      className="inline-flex  gap-2 items-center px-3 text-xs text-gray-900 bg-gray-100 border rounded-e-0 border-gray-100 border-s-0 rounded-e-md "
                    >
                      {isDniLoading ? (
                        <FormLoader colour={"#F64000"} className={" w-4"} />
                      ) : (
                        <>
                          Validar
                          <FaCheck />
                        </>
                      )}
                    </button>
                  )}
                </div>
              </div>

              {/* RUC */}
              <div className="mb-2 w-full">
                <label className="text-xs block text-gray-700 mb-1">
                  RUC
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-100 border rounded-e-0 border-gray-100 border-e-0 rounded-s-md">
                    <FaIdCardAlt />
                  </span>
                  <input
                    type="text"
                    placeholder="RUC del usuario"
                    required
                    value={newClientData.ruc}
                    onChange={(e) => setNewClientData((prev) => ({...prev, ruc: e.target.value}))}
                    className="text-xs rounded-none border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-100 p-2.5" 
                  />

                  {rucVerify ? (
                    <div className="inline-flex gap-2 items-center px-3 text-xs text-white bg-green-500 border border-s-0 rounded-e-0 border-gray-100 border-e-0 rounded-e-md ">
                      Validado
                      <FaCheck className=" text-white" />
                    </div>
                  ) : (
                    <button
                      type="button"
                      onClick={() => rucCheckHandler({ruc: newClientData.ruc, setter: setNewClientData})}
                      disabled={isRucLoading}
                      className="inline-flex  gap-2 items-center px-3 text-xs text-gray-900 bg-gray-100 border rounded-e-0 border-gray-100 border-s-0 rounded-e-md "
                    >
                      {isDniLoading ? (
                        <FormLoader colour={"#F64000"} className={" w-4"} />
                      ) : (
                        <>
                          Validar
                          <FaCheck />
                        </>
                      )}
                    </button>
                  )}
                </div>
              </div>

              {/* Nombre comercial */}
              <div className="mb-2 w-full">
                <label
                  htmlFor="name"
                  className="block mb-2 text-xs font-medium  text-black"
                >
                  Nombre Comercial  <span className="text-red-500">*</span>
                </label>
                <input
                  type={"text"}
                  id="name"
                  value={newClientData.nombre}
                  onChange={(e) =>
                    setNewClientData((prev) => ({
                      ...prev,
                      nombre: e.target.value,
                    }))
                  }
                  className="border text-xs rounded-lg  block w-full p-2  bg-white  border-gray-300 placeholder-gray-700 text-gray-700 "
                  placeholder=""
                  required
                />
              </div>

              {/* Email */}
              <div className="mb-2 w-full">
                <label
                  htmlFor="email"
                  className="block mb-2 text-xs font-medium  text-black"
                >
                  Email  <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  value={newClientData.email}
                  onChange={(e) => {
                    setNewClientData((prev) => ({
                      ...prev,
                      email: e.target.value,
                    }))
                    setClientEmail(e.target.value)
                  }}
                  className=" border   text-xs rounded-lg  block w-full p-2  bg-white  border-gray-300 placeholder-gray-700 text-gray-700 "
                  placeholder="name@afectansa.com"
                  required
                />
              </div>

              {/* Contraseña */}
              <div className="mb-2 w-full">
                <label
                  htmlFor="password"
                  className="block mb-2 text-xs font-medium  text-black"
                >
                  Contraseña  <span className="text-red-500">*</span>
                </label>
                <input
                  type="password"
                  id="password"
                  value={newClientData.password}
                  onChange={(e) => {
                    setNewClientData((prev) => ({
                      ...prev,
                      password: e.target.value,
                    }))
                    setClientPassword(e.target.value)
                  }}
                  className=" border   text-xs rounded-lg  block w-full p-2  bg-white  border-gray-300 placeholder-gray-700 text-gray-700 "
                  required
                />
              </div>

              {/* Rubro */}
              <div className="mb-2 w-full">
                <label htmlFor="rubro" className="block mb-2 text-xs">
                  Rubro <span className="text-red-500 ">*</span>
                </label>
                <select
                  type="text"
                  id="rubro"
                  value={currentRubro}
                  onChange={(e) => setCurrentRubro(e.target.value)}
                  className="w-full p-2 border text-xs border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
                  required
                >
                  <option value={""}>Selecciona un rubro</option>
                  {listRubros.map((e) => (
                    <option key={e.id} value={e.id}>
                      {e.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Nicho */}
              <div className="mb-2 w-full">
                <label htmlFor="rubro" className="block mb-2 text-xs">
                  Nicho <span className="text-red-500">*</span>
                </label>
                <select
                  type="text"
                  id="rubro"
                  value={nicho}
                  onChange={(e) => { setCurrentRubro(listNichos.find((nic)=>nic.id === Number(e.target.value))?.rubro.id); setNicho(e.target.value)}}
                  className="w-full p-2 border text-xs border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
                  required
                >
                  <option value={""}>Selecciona un nicho</option>
                  {listNichos.map((e) => (
                    <option key={e.id} value={e.id}>
                      {e.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* País */}
              <div className="mb-2 w-full">
                <label htmlFor="rubro" className="block mb-2 text-xs">
                  País <span className="text-red-500">*</span>
                </label>
                <select
                  type="text"
                  id="pais"
                  value={currentCountry}
                  onChange={(e) => {
                    setCurrentCountry(e.target.value)
                    countryCodeHandler({countryId: e.target.value, setter: setNewClientData})
                  }}
                  className="w-full p-2 border border-gray-300 rounded-lg text-xs focus:outline-none focus:border-blue-500"
                  required
                >
                  {countryNames.map(country => (
                    <option key={country.id} value={country.id}>
                      {country.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Razón Social */}
              <div className="mb-2 w-full">
                <label
                  htmlFor="razonSocial"
                  className="block mb-2 text-xs font-medium  text-black"
                >
                  Razón Social  <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="razonSocial"
                  value={newClientData.razonSocial}
                  onChange={(e) =>setNewClientData((prev) => ({ ...prev, razonSocial: e.target.value }))}
                  className="border text-xs rounded-lg block w-full p-2 bg-white border-gray-300 placeholder-gray-700 text-gray-700"
                  placeholder="Marca 123"
                  required
                />
              </div> 

              {/* Fecha de aniversario */}
              <div className="mb-2 w-full">
                <div>
                  <label
                    htmlFor={"fechaCotizacionLimite"}
                    class="block mb-2 text-xs font-medium text-gray-900 "
                  >
                    Fecha de aniversario
                  </label>
                  <Datepicker
                    popoverDirection={"down"}
                    toggleClassName="absolute bg-blue-300 text-xs rounded-r-lg text-white right-0 h-full px-3 text-gray-400 focus:outline-none disabled:opacity-40 disabled:cursor-not-allowed"
                    inputClassName={"rounded-lg w-full  text-xs  border border-gray-300  py-2  px-10 text-gray-700"}
                    inputId="fechaCotizacionLimite"
                    containerClassName={" relative"}
                    useRange={false}
                    asSingle={true}
                    classNames={" z-[9999]"}
                    placeholder={"Fecha de aniversario"}
                    value={newClientData.fechaAniversario}
                    onChange={(e) =>
                      setNewClientData((prev) => ({ ...prev, fechaAniversario: e }))
                    }
                  />
                </div>
              </div>

              {/* Dirección */}
              <div className="mb-2 w-full">
                <label
                  htmlFor="direccion"
                  className="block mb-2 text-xs font-medium  text-black"
                >
                  Direccion
                </label>
                <input
                  type="text"
                  id="direccion"
                  value={newClientData.direccion}
                  onChange={(e) =>setNewClientData((prev) => ({ ...prev, direccion: e.target.value }))}
                  className="border text-xs rounded-lg block w-full p-2 bg-white border-gray-300 placeholder-gray-700 text-gray-700"
                  placeholder="Calle 123"
                />
              </div>

            </div>

            <div className="flex flex-col gap-2 items-center justify-center w-1/2">

              {/* N° Empleados */}
              <div className="mb-2 w-full">
                <label
                  htmlFor="nEmpleados"
                  className="block mb-2 text-xs font-medium  text-black"
                >
                  N° Empleados
                </label>
                <input
                  type="text"
                  id="nEmpleados"
                  value={newClientData.nEmpleados}
                  onChange={(e) => setNewClientData((prev) => ({ ...prev, nEmpleados: e.target.value }))}
                  className="border text-xs rounded-lg block w-full p-2 bg-white border-gray-300 placeholder-gray-700 text-gray-700"
                  placeholder="10"
                  required={false}
                />
              </div>

              {/* Ingresos anuales */}
              <div className="mb-2 w-full">
                <label
                  htmlFor="ingresosAnuales"
                  className="block mb-2 text-xs font-medium  text-black"
                >
                  Ingresos anuales
                </label>
                <input
                  type="text"
                  id="ingresosAnuales"
                  value={newClientData.ingresosAnuales}
                  onChange={(e) => setNewClientData((prev) => ({ ...prev, ingresosAnuales: e.target.value }))}
                  className="border text-xs rounded-lg block w-full p-2 bg-white border-gray-300 placeholder-gray-700 text-gray-700"
                  placeholder="500 S/. - 800 S/."
                  required={false}
                />
              </div>

              {/* Nombre gerente */}
              <div className="mb-2 w-full">
                <label
                  htmlFor="nombreGerente"
                  className="block mb-2 text-xs font-medium  text-black"
                >
                  Nombre gerente
                </label>
                <input
                  type="text"
                  id="nombreGerente"
                  value={newClientData.nombreGerente}
                  onChange={(e) => setNewClientData((prev) => ({ ...prev, nombreGerente: e.target.value }))}
                  className="border text-xs rounded-lg block w-full p-2 bg-white border-gray-300 placeholder-gray-700 text-gray-700"
                  placeholder="Paco"
                  required={false}
                />
              </div>

              {/* Cumpleaños gerente */}
              <div className="mb-2 w-full">
                <div>
                  <label
                    htmlFor={"fechaCotizacionLimite"}
                    class="block mb-2 text-xs font-medium text-gray-900 "
                  >
                    Cumpleaños Gerente
                  </label>
                  <Datepicker
                    popoverDirection={"down"}
                    toggleClassName="absolute bg-blue-300 text-xs rounded-r-lg text-white right-0 h-full px-3 text-gray-400 focus:outline-none disabled:opacity-40 disabled:cursor-not-allowed"
                    inputClassName={"rounded-lg w-full text-xs border border-gray-300  py-2  px-10 text-gray-700 "}
                    inputId="cumpleaniosGerente"
                    containerClassName={" relative"}
                    useRange={false}
                    asSingle={true}
                    classNames={" z-[9999]"}
                    placeholder={"Cumpleaños de gerente"}
                    value={newClientData.cumpleaniosGerente}
                    
                    onChange={(e) =>
                      setNewClientData((prev) => ({
                        ...prev,
                        cumpleaniosGerente: e,
                      }))
                    }
                  />
                </div>
              </div>

              {/* Fecha cumpleaños (Encargado del proyecto) */}
              <div className="mb-2 w-full">
                <div>
                  <label
                    htmlFor={"fechaCumpleanios"}
                    class="block mb-2 text-xs font-medium text-gray-900 "
                  >
                    Fecha cumpleaños (Encargado del proyecto)
                  </label>
                  <Datepicker
                    popoverDirection={"up"}
                    toggleClassName="absolute bg-blue-300 text-xs rounded-r-lg text-white right-0 h-full px-3 text-gray-400 focus:outline-none disabled:opacity-40 disabled:cursor-not-allowed"
                    inputClassName={"rounded-lg w-full text-xs border border-gray-300  py-2  px-10 text-gray-700 "}
                    inputId="fechaCumpleanios"
                    containerClassName={" relative"}
                    useRange={false}
                    asSingle={true}
                    classNames={" z-[9999]"}
                    placeholder={"Fecha de cumpleaños"}
                    value={newClientData.fechaCumpleanios}
                    onChange={(e) =>
                      setNewClientData((prev) => ({ ...prev, fechaCumpleanios: e }))
                    }
                  />
                </div>
              </div>

              {/* Teléfono gerente */}
              <div className="mb-2 w-full">
                <label
                  htmlFor="telefonoGerente"
                  className="block mb-2 text-xs font-medium  text-black"
                >
                  Teléfono gerente
                </label>
                <input
                  type="text"
                  id="telefonoGerente"
                  value={newClientData.telefonoGerente}
                  onChange={(e) => setNewClientData((prev) => ({ ...prev, telefonoGerente: e.target.value }))}
                  className="border text-xs rounded-lg block w-full p-2 bg-white border-gray-300 placeholder-gray-700 text-gray-700"
                  placeholder="123456789"
                  required={false}
                />
              </div>

              {/* Email gerencia */}
              <div className="mb-2 w-full">
                <label
                  htmlFor="emailGerencia"
                  className="block mb-2 text-xs font-medium  text-black"
                >
                  Email gerencia
                </label>
                <input
                  type="text"
                  id="emailGerencia"
                  value={newClientData.emailGerencia}
                  onChange={(e) => setNewClientData((prev) => ({ ...prev, emailGerencia: e.target.value }))}
                  className="border text-xs rounded-lg block w-full p-2 bg-white border-gray-300 placeholder-gray-700 text-gray-700"
                  placeholder="gerencia@empresa.com"
                  required={false}
                />
              </div>

              {/* Encargado del proyecto */}
              <div className="mb-2 w-full">
                <label
                  htmlFor="encargadoProyecto"
                  className="block mb-2 text-xs font-medium  text-black"
                >
                  Encargado del proyecto <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="encargadoProyecto"
                  value={newClientData.encargadoProyecto}
                  onChange={(e) => setNewClientData((prev) => ({ ...prev, encargadoProyecto: e.target.value }))}
                  className="border text-xs rounded-lg block w-full p-2 bg-white border-gray-300 placeholder-gray-700 text-gray-700"
                  placeholder="Nombre encargado"
                  required
                />
              </div>

              {/* Teléfono de encargado de proyecto */}
              <div className="mb-2 w-full">
                <label
                  htmlFor="telefono"
                  className="block mb-2 text-xs font-medium  text-black"
                >
                  Teléfono de encargado de proyecto <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="telefono"
                  value={newClientData.telefono}
                  onChange={(e) => setNewClientData((prev) => ({ ...prev, telefono: e.target.value }))}
                  className="border text-xs rounded-lg block w-full p-2 bg-white border-gray-300 placeholder-gray-700 text-gray-700"
                  placeholder="123456789"
                  required
                />
              </div>

              {/* Puesto de trabajo */}
              <div className="mb-2 w-full">
                <label
                  htmlFor="telefono"
                  className="block mb-2 text-xs font-medium  text-black"
                >
                  Puesto de Trabajo
                </label>
                <input
                  type="text"
                  id="telefono"
                  value={newClientData.puestoTrabajo}
                  onChange={(e) => setNewClientData((prev) => ({ ...prev, puestoTrabajo: e.target.value }))}
                  className="border text-xs rounded-lg block w-full p-2 bg-white border-gray-300 placeholder-gray-700 text-gray-700"
                  placeholder="Jefe"
                />
              </div>

            </div>

          </div>

        </div>

        <Button 
          variant="contained"
          type="submit"
          sx={{
            fontWeight: "bold",
            fontFamily: "poppins",
            paddingBlock: "4px",
            backgroundColor: "#ff6400",
            transform: "all",
            marginTop: "20px",
            animationDuration: "1000",
            textTransform: "none",
            borderRadius: "8px",
            width: "100%",
            '&:hover': {
              backgroundColor: "#bb4a03",
            }
          }}
        >
          Guardar
        </Button>

      </form>

    </ModalInDrawer>
  );
};

export default NuevoClienteDialog;
